import styled, { css } from 'styled-components';
import { ReactComponent as SuccessIconSvg } from 'products/nomad_insurance/assets/img/icons/checkmark.svg';
import { ReactComponent as FailureIconSvg } from 'assets/img/icons/failure-icon.svg';
import { ReactComponent as WarningIconSvg } from 'assets/img/icons/warning-icon.svg';
import { ReactComponent as InfoIconSvg } from 'products/nomad_insurance/assets/img/icons/info.svg';
import { ReactComponent as StarIconSvg } from 'assets/img/icons/star-icon.svg';
import { variants, th } from 'style/theme';
import { sizes } from 'style';

const redVariant = css`
  background-color: ${th('colors.fuzzyWuzzyBrown+4')};
  border: 2px solid ${th('colors.fuzzyWuzzyBrown')};
  color: ${th('colors.pickledBluewood')};
`;

export const FeedbackContainer = styled.div`
  padding: 10px 16px;
  border-radius: 16px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;

  @media ${sizes.tabletLandscape} {
    display: flex;
    flex-direction: row;
    gap: 10px;

    ${({ topAlignIcon }) =>
      topAlignIcon &&
      css`
        align-items: flex-start;

        > svg {
          margin-top: 2px;
        }
      `};
  }

  ${variants('variant', {
    success: css`
      background-color: ${th('colors.sushi+4')};
      border: 2px solid ${th('colors.sushi')};
    `,
    failure: redVariant,
    warning: redVariant,
    warningOrange: css`
      background-color: ${th('colors.porsche+4')};
      border: 2px solid ${th('colors.porsche')};
      color: ${th('colors.porsche-2')};
    `,
    info: css`
      background-color: ${th('colors.pictonBlue+4')};
      border: 2px solid ${th('colors.pictonBlue+1')};
    `,
    infoYellow: css`
      background-color: ${th('colors.confetti+4')};
      border: 2px solid ${th('colors.confetti+1')};
    `
  })}
`;

const iconStyles = css`
  display: inline;
  width: 100%;
  max-width: 20px;
  height: auto;
  margin-right: 10px;
  vertical-align: text-top;

  @media ${sizes.tabletLandscape} {
    margin-right: 0;
  }
`;

export const SuccessIcon = styled(SuccessIconSvg)`
  ${iconStyles};
`;

export const FailureIcon = styled(FailureIconSvg)`
  ${iconStyles};
`;

export const WarningIcon = styled(WarningIconSvg)`
  ${iconStyles};
`;

export const OrangeWarningIcon = styled(FailureIconSvg)`
  ${iconStyles};
  > path {
    fill: ${th('colors.porsche')};
  }
`;

export const InfoIcon = styled(InfoIconSvg)`
  ${iconStyles};
  > path {
    fill: ${th('colors.pictonBlue+1')};
  }
`;

export const StarIcon = styled(StarIconSvg)`
  ${iconStyles};
`;

export const Text = styled.span`
  margin: 0;
`;

export const BoldText = styled(Text)`
  font-weight: 500;
`;
